import React from 'react';
import { IconSvg, Box } from '@utex/ui-kit';
import { LoginBlock } from '../LoginBlock';
import { UserInfo } from '../UserInfo';

interface Props {
  isAuthorized: boolean | undefined;
  onLogin: () => void;
  onRegistration: () => void;
  profileLink: string;
  onUserClick: () => void;
  isBottomBorderVisible?: boolean;
}

export const UserBlock: React.FC<Props> = ({
  isAuthorized,
  profileLink,
  onRegistration,
  onLogin,
  onUserClick,
  isBottomBorderVisible,
}) => {
  if (isAuthorized === undefined) {
    return (
      <Box textAlign="center" marginBottom={17}>
        <IconSvg src="preloader" width={30} height={30} />
      </Box>
    );
  }
  if (isAuthorized) {
    return (
      <UserInfo
        onClick={onUserClick}
        profileLink={profileLink}
        isBottomBorderVisible={isBottomBorderVisible}
      />
    );
  }
  return <LoginBlock onRegistration={onRegistration} onLogin={onLogin} />;
};
